const productInfo = {
    snofers: {
        banner: {
            image: "../../../images/portfolio/product/snofers/snofers-banner.webp",
            title1: "Snofers",
            title2: "Grocery Delivery Platform"
        },
        description: "Snofers is an app that stimulate the way people buy grocery or get things picked up and delivered to their homes. With just a touch of a few buttons, anyone can order, cancel, approve, track and get your order in minium time. We have designed three flows of the app, One where the snofer's driver can either pick up the ordered items or can purchase items requested by the users through the app. Also the admin can see the ordered items in app and can select delivery boy to delivery from the nearest store.",
        featuredProduct: [
            {
                id: 1,
                image: '../../../images/portfolio/product/snofers/1.webp',
                title: 'Featured App Main Page',
                description:'While placing the order on Gofer app, we provided users the option to order from featured list provided on home page or search a product based on their preference. To enhance the overall experience as well as generate revenue for our client, we suggested that he introduce offers and discounts for stores in the home screen. The home page have different listing type as Top selling, Recent, Deal of the day etc. This view will encourage the customer to buy product and generate sale.',
            },
            {
                id: 2,
                image: '../../../images/portfolio/product/snofers/2.webp',
                title: 'Decent Category View',
                description:'While creating a seamless flow for the users while placing an order, we had to first understand the users and their mindset. We analysed the information and the knowledge our users i.e customers would have and then went onto design a relevant feature. To simplify things while placing orders, we added a decent listing of the category view. This was one of the key UX features on the application.',
            },
            {
                id: 3,
                image: '../../../images/portfolio/product/snofers/3.webp',
                title: 'Book Specific Slot',
                description:'There was a major challenge we faced while devising the slot selection module for the users and the drivers. After a few fallbacks we are able to provide a feature to select a delivery slot for deliver. Now customer will choose a slot for delivery that will make the delivery process simpler. The driver would receive notification for slots booked for him along with the order details he need to delivery.',
            },
        ],
        features: [
            {
                id: 1,
                title: 'Featured Home Page',
                description:'Most common features for grocery plateform',
                className: 'icon-rounded trophy'
            },
            {
                id: 2,
                title: 'Deal of the day',
                description:'Discounted Product on deal of day listing',
                className: 'icon-rounded thumbsup'
            },
            {
                id: 3,
                title: 'Recent Products',
                description:'Trending item in recent product list',
                className: 'icon-rounded list'
            },
            {
                id: 4,
                title: 'Newly Added Product',
                description:'Whats new - listing of newly added products',
                className: 'icon-rounded add-circle'
            },
            {
                id: 5,
                title: 'Item List with Image view',
                description:'List of all the product with latest images',
                className: 'icon-rounded image'
            },
            {
                id: 6,
                title: 'Delivery Slot Selection',
                description:'Delivery slot slection for delivery',
                className: 'icon-rounded clock'
            },
            {
                id: 7,
                title: 'Pick Address Using Map View',
                description:'Pick proper address using map view',
                className: 'icon-rounded flag'
            },
            {
                id: 8,
                title: 'Cash On Delivery',
                description:'Cash on delivery available',
                className: 'icon-rounded cash'
            },
        ],
        technology: [
            { name: 'Java' },
            { name: 'Android' },
            { name: 'PHP' },
        ], 
        screenshotBanner: [
            { name: '../../../images/portfolio/product/snofers/snofer-final.webp' },
        ]
    },

    gotaxi: {
        banner: {
            image: "../../../images/portfolio/product/gotaxi/gotaxi-banner.webp",
            title1: "GoTaxi",
            title2: "Cab Booking Service"
        },
        description: "GoTaxi is a very convenient and pocket-friendly online cab booking application that connect the gap between taxi owners and their end customers. This application is a complete responsive cab business management software built on PHP with Laravel Framework; This is an fast, effective and user-friendly way for passengers to hire cabs and a powerful web application to execute customer requests. The main highlight of the application is the well-formed admin portal to monitor and process the entire management.",
        featuredProduct: [
            {
                id: 1,
                image: '../../../images/portfolio/product/gotaxi/1.webp',
                title: 'Effective User Interface',
                description:'While creating a seamless and plesent flow for the users while booking a cab, we had to first understand the users and their mindset. We analysed the information and the knowledge our users i.e rider would have and then went onto design a relevant user interface for the application. To simplify things while booking a cab or taxi.',
            },
            {
                id: 2,
                image: '../../../images/portfolio/product/gotaxi/2.webp',
                title: 'Easy booking and payment.',
                description:'The major part of the application which is mostly focused while development is to make the booking and payment process seamless. We have build the booking process so that the booking can be done with in few clicks. Also we have added multiple payment options along with wallet to make it easy to pay while booking a ride.',
            },
            {
                id: 3,
                image: '../../../images/portfolio/product/gotaxi/3.webp',
                title: 'Efficient monitoring',
                description:'There was a major challenge we faced while devising monitoring module for the users and the drivers. After a few fallbacks we are able to provide a featured dashboard to monitor each and every ride of a customer. Now the admin will be able to view all the activities along with numbers to monitor the application process.',
            },
        ],
        features: [
            {
                id: 1,
                title: 'User Management',
                description:'Admin can manage all user type',
                className: 'icon-rounded user'
            },
            {
                id: 2,
                title: 'Driver Management',
                description:'Admin can manage driver access',
                className: 'icon-rounded car'
            },
            {
                id: 3,
                title: 'Promo Code Management',
                description:'Create or update promo codes',
                className: 'icon-rounded list'
            },
            {
                id: 4,
                title: 'Usage Google Map',
                description:'Google map integration for perfect direction',
                className: 'icon-rounded flag'
            },
            {
                id: 5,
                title: 'Mannual Booking Option',
                description:'Mannual booking process is also there',
                className: 'icon-rounded hand'
            },
            {
                id: 6,
                title: 'Wallet Configured',
                description:'Can and pay via wallet',
                className: 'icon-rounded cash'
            },
            {
                id: 7,
                title: 'Complete Function Website',
                description:'Can do all process via website also',
                className: 'icon-rounded globe'
            },
            {
                id: 8,
                title: 'Responsive User Interface',
                description:'User interface is fully optimized and responsive',
                className: 'icon-rounded monitor'
            },
        ],
        technology: [
            { name: 'Java' },
            { name: 'Android' },
            { name: 'PHP' },
            { name: 'Laravel' },
        ], 
        screenshotBanner: [
            { name: '../../../images/portfolio/product/gotaxi/gotaxi-final.webp' },
        ]
    }
}

export default productInfo;